import React, { useState, useEffect } from 'react';
import Grid from '@material-ui/core/Grid';
import Cookies from 'js-cookie';
import Typography from '@material-ui/core/Typography';
import { Button, TextField, Box, FormControl, InputLabel, Select, MenuItem, Checkbox, ListItemText, FormControlLabel, Switch, CircularProgress } from "@material-ui/core";
import Autocomplete from '@material-ui/lab/Autocomplete';
import { styled } from '@material-ui/styles';
import { useHistory } from "react-router-dom";

import api from '../../../../../services/api';
import NavegadorGestao from "../../../../../components/NavBarGestao";

const ColorButtonBlue = styled(Button)(({ theme }) => ({
    color: 'white',
    backgroundColor: 'blue',
    borderColor: 'black',
    '&:hover': {
        backgroundColor: 'darkblue',
        color: 'white',
    },
}));

export default function CadastrarPessoaInteresse() {
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    
    const [nome, setNome] = useState('');
    const [cpf, setCpf] = useState('');
    const [endereco, setEndereco] = useState('');
    const [fotoBase64, setFotoBase64] = useState('');
    const [horarioInicio, setHorarioInicio] = useState('00:00');
    const [horarioFim, setHorarioFim] = useState('23:59');
    const [permissaoMestre, setPermissaoMestre] = useState(false);

    const [instalacoesDisponiveis, setInstalacoesDisponiveis] = useState([]);
    const [instalacoesSelecionadas, setInstalacoesSelecionadas] = useState([]);
    const [instalacoesCache, setInstalacoesCache] = useState([]);
    const [loadingInstalacoes, setLoadingInstalacoes] = useState(false);

    const initialDays = [
        { name: "Segunda-feira", key: "segunda", active: false, start: "08:00", end: "18:00" },
        { name: "Terça-feira", key: "terca", active: false, start: "08:00", end: "18:00" },
        { name: "Quarta-feira", key: "quarta", active: false, start: "08:00", end: "18:00" },
        { name: "Quinta-feira", key: "quinta", active: false, start: "08:00", end: "18:00" },
        { name: "Sexta-feira", key: "sexta", active: false, start: "08:00", end: "18:00" },
        { name: "Sábado", key: "sabado", active: false, start: "08:00", end: "18:00" },
        { name: "Domingo", key: "domingo", active: false, start: "08:00", end: "18:00" }
    ];
    const [diasSemana, setDiasSemana] = useState(initialDays);

    const handlePesquisarInstalacoes = async (termo) => {
        if (!termo || termo.length < 4) {
            setInstalacoesDisponiveis([]);
            return;
        }
        setLoadingInstalacoes(true);
        try {
            const token = Cookies.get('token');
            const resp = await api.get(`v1/protected/cliente/instalacoes/buscar/${encodeURIComponent(termo)}`, { headers: { Authorization: "Bearer " + token }});
            
            // Adicionar ao cache para não perder o nome de quem já foi selecionado
            const novas = resp.data;
            const novoCache = [...instalacoesCache];
            novas.forEach(inst => {
                if (!novoCache.find(c => c.id_instalacao === inst.id_instalacao)) {
                    novoCache.push(inst);
                }
            });
            setInstalacoesCache(novoCache);
            setInstalacoesDisponiveis(novas);
        } catch(e) {
            console.error("Erro ao pesquisar instalações", e);
        }
        setLoadingInstalacoes(false);
    };

    const handleDiaChange = (index, field, value) => {
        const novosDias = [...diasSemana];
        novosDias[index][field] = value;
        setDiasSemana(novosDias);
    };

    const handleSalvar = async () => {
        if (!nome || !nome.trim()) {
            alert("Preencha o nome!");
            return;
        }

        setLoading(true);
        const token = Cookies.get('token');
        const headers = { Authorization: "Bearer " + token };
        
        const horariosJson = {};
        diasSemana.forEach(dia => {
            horariosJson[dia.key] = { ativo: dia.active, inicio: dia.start, fim: dia.end };
        });

        const payload = {
            nome: nome,
            cpf: cpf,
            endereco: endereco,
            foto_facial_criptografada: fotoBase64,
            status: 1,
            horario_padrao_inicio: horarioInicio,
            horario_padrao_fim: horarioFim,
            permissao_mestre: permissaoMestre ? 1 : 0,
            instalacoesIds: permissaoMestre ? [] : instalacoesSelecionadas.map(v => v.id_instalacao),
            horarios_dias_semana: JSON.stringify(horariosJson)
        };

        try {
            const response = await api.post('/v1/protected/pessoas-interesse/cadastrar', payload, { headers });
            alert("Cadastrado com sucesso!");
            history.push(`/gestao/administracao/pessoasinteresse/editar/${response.data.id_pessoa}`);
        } catch (error) {
            console.error("Erro ao cadastrar", error);
            alert("Erro ao cadastrar pessoa.");
        }
        setLoading(false);
    };

    return (
        <Grid container spacing={0} style={{ margin: 0, padding: 0 }}>
            <NavegadorGestao BaseDados="marcado" PessoasInteresse="marcado" />

            <Grid item xs={12} sm={10} style={{ padding: '20px' }}>
                <Typography variant="h4" style={{ marginBottom: '20px' }}>
                    Cadastrar Pessoa de Interesse
                </Typography>

                <Box display="flex" flexDirection="column" gap={2} maxWidth="700px">
                    <TextField 
                        label="Nome Completo" 
                        variant="outlined" 
                        fullWidth 
                        value={nome}
                        onChange={(e) => setNome(e.target.value)}
                    />
                    
                    <TextField 
                        label="CPF" 
                        variant="outlined" 
                        fullWidth 
                        value={cpf}
                        onChange={(e) => setCpf(e.target.value)}
                    />
                    
                    <TextField 
                        label="Endereço" 
                        variant="outlined" 
                        fullWidth 
                        value={endereco}
                        onChange={(e) => setEndereco(e.target.value)}
                    />

                    <FormControlLabel
                        control={<Switch checked={permissaoMestre} onChange={(e) => setPermissaoMestre(e.target.checked)} color="primary" />}
                        label="Permissão Mestre (Acesso a TODAS as instalações restrito apenas pelo horário)"
                        style={{ marginTop: 10, marginBottom: 10 }}
                    />

                    {!permissaoMestre && (
                        <Box style={{ marginTop: 10 }}>
                            <Autocomplete
                                multiple
                                id="instalacoes-autocomplete"
                                options={instalacoesDisponiveis}
                                getOptionLabel={(option) => option.nome_fantasia || option.nome_empresarial || option.nome || String(option.id_instalacao)}
                                getOptionSelected={(option, value) => option.id_instalacao === value.id_instalacao}
                                value={instalacoesSelecionadas}
                                onChange={(event, newValue) => {
                                    setInstalacoesSelecionadas(newValue);
                                }}
                                onInputChange={(event, newInputValue, reason) => {
                                    if (reason === 'input') {
                                        handlePesquisarInstalacoes(newInputValue);
                                    }
                                }}
                                filterOptions={(x) => x}
                                loading={loadingInstalacoes}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        label="Instalações Vinculadas (Acesso)"
                                        placeholder="Digite 4 ou mais letras da instalação..."
                                        InputProps={{
                                            ...params.InputProps,
                                            endAdornment: (
                                                <React.Fragment>
                                                    {loadingInstalacoes ? <CircularProgress color="inherit" size={20} /> : null}
                                                    {params.InputProps.endAdornment}
                                                </React.Fragment>
                                            ),
                                        }}
                                    />
                                )}
                            />
                        </Box>
                    )}
                    
                    <Box mt={2}>
                        <Typography variant="body2" color="textSecondary" gutterBottom>
                            Foto Facial (A foto será enviada de forma criptografada para o servidor)
                        </Typography>
                        <input
                            accept="image/*"
                            style={{ display: 'none' }}
                            id="raised-button-file"
                            type="file"
                            onChange={(e) => {
                                const file = e.target.files[0];
                                if (file) {
                                    const reader = new FileReader();
                                    reader.onloadend = () => {
                                        setFotoBase64(reader.result);
                                    };
                                    reader.readAsDataURL(file);
                                }
                            }}
                        />
                        <label htmlFor="raised-button-file">
                            <Button variant="outlined" component="span" color="primary">
                                Selecionar Imagem
                            </Button>
                        </label>
                        {fotoBase64 && (
                            <Box mt={2}>
                                <img src={fotoBase64} alt="Preview" style={{ width: '150px', borderRadius: '8px' }} />
                            </Box>
                        )}
                    </Box>
                    
                    <Box mt={3}>
                        <Typography variant="h6" style={{ marginBottom: 10 }}>Configuração de Horários (Padrão)</Typography>
                        <Box display="flex" gap={2}>
                            <TextField
                                label="Horário Padrão Início"
                                type="time"
                                variant="outlined"
                                InputLabelProps={{ shrink: true }}
                                value={horarioInicio}
                                onChange={(e) => setHorarioInicio(e.target.value)}
                            />
                            <TextField
                                label="Horário Padrão Fim"
                                type="time"
                                variant="outlined"
                                InputLabelProps={{ shrink: true }}
                                value={horarioFim}
                                onChange={(e) => setHorarioFim(e.target.value)}
                            />
                        </Box>
                    </Box>

                    <Box mt={3} mb={1}>
                        <Typography variant="h6">Horários de Acesso por Dia da Semana</Typography>
                        <Typography variant="body2" color="textSecondary" style={{ marginBottom: 15 }}>
                            Habilite os dias e defina a faixa de horário em que o acesso é permitido.
                        </Typography>
                        
                        {diasSemana.map((dia, index) => (
                            <Box key={dia.key} display="flex" alignItems="center" gap={2} mb={2}>
                                <div style={{ width: '180px' }}>
                                    <FormControlLabel
                                        control={
                                            <Switch 
                                                color="primary" 
                                                checked={dia.active} 
                                                onChange={(e) => handleDiaChange(index, 'active', e.target.checked)} 
                                            />
                                        }
                                        label={dia.name}
                                    />
                                </div>
                                <TextField
                                    label="Início"
                                    type="time"
                                    variant="outlined"
                                    size="small"
                                    disabled={!dia.active}
                                    InputLabelProps={{ shrink: true }}
                                    value={dia.start}
                                    onChange={(e) => handleDiaChange(index, 'start', e.target.value)}
                                />
                                <TextField
                                    label="Fim"
                                    type="time"
                                    variant="outlined"
                                    size="small"
                                    disabled={!dia.active}
                                    InputLabelProps={{ shrink: true }}
                                    value={dia.end}
                                    onChange={(e) => handleDiaChange(index, 'end', e.target.value)}
                                />
                            </Box>
                        ))}
                    </Box>

                    <Box mt={3} mb={5}>
                        <ColorButtonBlue 
                            variant="contained" 
                            onClick={handleSalvar}
                            disabled={loading}
                        >
                            Salvar e Continuar
                        </ColorButtonBlue>
                        
                        <Button 
                            style={{ marginLeft: 10 }}
                            variant="outlined" 
                            onClick={() => history.push('/gestao/administracao/pessoasinteresse/listar')}
                        >
                            Cancelar
                        </Button>
                    </Box>
                </Box>
            </Grid>
        </Grid>
    );
}
